
















import { Component, Vue, Prop } from 'vue-property-decorator';
import GuestbookForm from '@/components/GuestbookForm.vue';
import GuestbookReader from '@/components/GuestbookReader.vue';

@Component({
  components: {
    GuestbookForm,
    GuestbookReader,
  },
  metaInfo: {
    title: 'Guestbook',
  },
  props: {
    isAuthenticated: Boolean,
    isAdmin: Boolean,
  },
})
export default class Guestbook extends Vue {}
